import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { Store } from '@ngrx/store';

import { AccountState, PermissionService, Rule } from 'src/app/core';
import { AccessCtrlDirective } from './access-ctrl.directive';

@Directive({
  selector: '[appAccessCtrlInv]',
})
export class AccessCtrlInvDirective extends AccessCtrlDirective {
  @Input() set appAccessCtrlInv(res: string) {
    this.processRule(res);
  }

  constructor(
    templateRef: TemplateRef<any>,
    permissionService: PermissionService,
    viewContainer: ViewContainerRef,
    store: Store<AccountState>
  ) {
    super(templateRef, permissionService, viewContainer, store);
  }

  action1(rule: Rule) {
    this.clearComponent();
    this.addStoredPermission(rule, false);
    return false;
  }

  action2(rule: Rule) {
    this.showComponent();
    this.addStoredPermission(rule, true);
    return true;
  }

  action3() {
    this.clearComponent();
    return false;
  }

  action4() {
    this.showComponent();
    return true;
  }
}
